export default {
  title: 'Liefersoft',
  form: {
    company_id: 'Company Id',
    login: 'Login',
    password: 'Password',
  },
  buttons: {
    save: 'Save',
    edit: 'Edit',
    cancel: 'Cancel',
  },
  toasts: {
    error: 'Failed to save changes',
    success: 'Changes got saved',
  },
  instructions: {
    title: 'Setup instructions:',
    steps: {
      1: 'Go to “Settings” > “Program Settings” > “API/Interfaces.”',
      2: 'Add a platform:\n• Click the “Platforms” button.\n• Enter a username (e.g., the name of the platform).\n• Click “Save”.',
      3: 'Copy API data:\n• After saving, a window with the API platform code will appear.\n• Copy the displayed data.',
    },
  },
  connected: {
    title: 'Liefersoft is connected',
    description: 'This integration is set up.',
  },
};
